var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVtmsLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 430.367,
    height: 336.975,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3704.99 2900.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0,.fil1,.fil2{fill:#fefefe}.fil0,.fil2{fill-rule:nonzero}.fil0{fill:#1c92c7}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1123.63 0h2581.36v2900.99H1123.63z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.17 120.14h2343.25v2660.72H1242.17z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.76 195.72h2188.83v2509.54H1317.76z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38 2372.67h1859.48V528.31H1.38z",
    className: "fil2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.21 1269.08h1148.94V891.14H364.21zM364.21 2009.85h1148.94v-377.94H364.21z",
    className: "fil2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 528.31h1860.86v1844.36H0z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.97 604.6h1708.3v1692.49H76.97z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.7 1631.91h1146.43v377.94H364.7z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.38 1722.62h969.06v196.53H453.38z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.7 891.14h1146.43v377.94H364.7z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.38 981.85h969.06v196.53H453.38z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2411.92,
    cy: 2070.88,
    r: 191.26,
    className: "fil1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1393470476384"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2992.2 1879.62c-105.63 0-191.27 85.63-191.27 191.26s85.63 191.27 191.27 191.27c105.63 0 191.26-85.64 191.26-191.27 0-105.63-85.63-191.26-191.26-191.26z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2756.68 2643.09 235.53.22 235.52-.22 11.56-1.09 12.65-2.18 14.39-4.36 16.79-7.63 13.52-8.94 11.56-10.03 11.12-11.99 10.03-16.14 5.89-13.09 6.32-20.28 1.96-17.66-.44-25.29-.87-30.53-1.53-26.39-2.83-21.59-2.83-17.01-5.24-22.68-5.45-24.42-6.98-18.97-7.63-18.97-10.91-20.5-9.81-15.48-13.96-16.79-14.83-13.3-14.39-9.81-11.78-6.54-18.75-7.2-16.79-3.49-15.7-1.96-12.65.65-7.41 2.84-9.16 5.45-17.45 11.78-20.71 13.52-22.68 12.87-26.17 10.69-29 8.94s0-.22-20.06 2.83l-25.31.44-25.31-.44c-20.06-3.05-20.06-2.83-20.06-2.83l-29-8.94-26.17-10.69-22.68-12.87-20.71-13.52-17.45-11.78-9.16-5.45-7.41-2.84-12.65-.65-15.7 1.96-16.79 3.49-18.75 7.2-11.78 6.54-14.39 9.81-3.16 2.84 11.66 10.46 13.96 16.79 9.81 15.48 10.91 20.5 7.63 18.97 6.98 18.97 5.45 24.42 5.24 22.68 2.83 17.01 2.83 21.59 1.53 26.39.87 30.53.44 25.29-1.96 17.66-6.32 20.28-5.89 13.09-10.03 16.14-11.12 11.99-11.56 10.03-13.52 8.94-16.79 7.63-2.94.89 11.45 3.47 12.65 2.18 11.56 1.09z",
    className: "fil1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m2176.4 2643.09 235.53.22 235.52-.22 11.56-1.09 12.65-2.18 14.39-4.36 16.79-7.63 13.52-8.94 11.56-10.03 11.12-11.99 10.03-16.14 5.89-13.08 6.33-20.28 1.96-17.66-.44-25.29-.87-30.53-1.53-26.38-2.83-21.59-2.84-17.01-5.23-22.68-5.45-24.42-6.98-18.97-7.63-18.97-10.9-20.5-9.81-15.48-13.96-16.79-14.83-13.3-14.39-9.81-11.78-6.54-18.75-7.19-16.79-3.49-15.7-1.97-12.65.65-7.41 2.84-9.16 5.45-17.45 11.78-20.71 13.52-22.68 12.87-26.17 10.69-29 8.94s0-.22-20.06 2.83l-25.31.44-25.31-.44c-20.06-3.05-20.06-2.83-20.06-2.83l-29-8.94-26.17-10.69-22.68-12.87-20.72-13.52-17.45-11.78-9.16-5.45-7.42-2.84-12.65-.65-15.7 1.97-16.79 3.49-18.75 7.19-11.78 6.54-14.39 9.81-14.83 13.3-13.96 16.79-9.81 15.48-10.9 20.5-7.63 18.97-6.98 18.97-5.45 24.42-5.23 22.68-2.84 17.01-2.83 21.59-1.53 26.38-.87 30.53-.44 25.29 1.96 17.66 6.33 20.28 5.89 13.08 10.03 16.14 11.12 11.99 11.56 10.03 13.52 8.94 16.79 7.63 14.39 4.36 12.65 2.18 11.56 1.09z",
    className: "fil1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtmsLeft);
export default __webpack_public_path__ + "static/media/vtms_left.48c826791d4091d26cbd24d90dfd4ee5.svg";
export { ForwardRef as ReactComponent };